import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { editOrganizationComment } from '@/api/v4/organization-comments.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { projectIdState } from '@/features/projects/project.state';
import { teamIdState } from '@/features/teams/team.state';
import { notify } from '@/ui/snackbar/notify';

import { companyIdState } from '../../company.state';
import { useAtomValue } from 'jotai';

export const useEditCompanyComment = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);
  const projectId = useAtomValue(projectIdState);
  const teamId = useAtomValue(teamIdState);

  const mutation = useMutation({
    mutationFn: editOrganizationComment,
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      console.error(error.message);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyComments, companyId, projectId, teamId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  return {
    editComment: mutation.mutateAsync,
    isError: mutation.isError,
  };
};
